import { createContext, useContext, useEffect, useMemo, useSyncExternalStore } from 'react'
import { maintenanceStore } from '@/services/maintenance'

const MaintenanceContext = createContext(null)

export function MaintenanceProvider({ children, isAuthenticated = true }) {
  const active = useSyncExternalStore(
    maintenanceStore.subscribe,
    maintenanceStore.getSnapshot,
    maintenanceStore.getSnapshot,
  )

  const value = useMemo(() => ({
    active,
    activate: maintenanceStore.activate,
    deactivate: maintenanceStore.deactivate,
  }), [active])

  useEffect(() => {
    if (!isAuthenticated) maintenanceStore.deactivate()
  }, [isAuthenticated])

  return (
    <MaintenanceContext.Provider value={value}>
      {children}
    </MaintenanceContext.Provider>
  )
}

export function useMaintenanceMode() {
  const context = useContext(MaintenanceContext)
  if (!context) throw new Error('useMaintenanceMode must be used within MaintenanceProvider')
  return context
}
